<div [formGroup]="timesheetForm" class="px-2">
    <!--    <pre>{{model | json:2}}</pre>-->
    <!-- MOBILE LAYOUT -->
    <div *ngIf="isMobile$ | async; else desktopTemplate">
        <div class="row row-border-bottom"></div>
        <ng-container *ngFor="let entry of model.value; index as $index">
            <!-- START OF WORK -->
            <div *ngIf="isSoW(entry)" class="row py-2 align-items-center row-border-bottom">
                <!-- Activity -->
                <div class="col-12">
                    <div class="row align-items-center">
                        <div class="col-4">
                            <label class="col-form-label" translate="TIMESHEET_TABLE_ACTIVITY_LABEL"></label>
                        </div>
                        <div class="col">
                            <label translate="TIMESHEET_START_OF_WORK_LABEL"></label>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <label class="col-form-label">
                        <span translate="TIMESHEET_TABLE_START_LABEL"></span>
                    </label>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-7 pe-0">
                            <pace-core-date-input
                                [(model)]="entry.startDate"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_START_OF_WORK_TABLE_START_DATE_LABEL' | translate"
                            ></pace-core-date-input>
                        </div>
                        <div class="col-5">
                            <pace-core-time-input
                                [(model)]="entry.startTime"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_START_OF_WORK_TABLE_START_TIME_LABEL' | translate"
                            ></pace-core-time-input>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END OF START OF WORK -->

            <!-- NOTIFICATION ENTRIES  -->
            <div *ngIf="isNormal(entry)" class="row py-2 align-items-center row-border-bottom">
                <!-- Activity -->
                <div class="col-4">
                    <label class="col-form-label" translate="TIMESHEET_TABLE_ACTIVITY_LABEL"></label>
                </div>
                <div class="col-8">
                    <!--                        normal entry activity-->
                    <label *ngIf="!isTravelBack(entry) || (isTravelBack(entry) && !entry.isTravelBackEditable)">
                        {{ getDesc(entry) }}
                        <ng-container *ngIf="displayMeansOfTransport && entry.meansOfTransport">
                            <span *ngIf="isTravelTo(entry) || (isTravelBack(entry) && !entry.isTravelBackEditable)">
                                | {{ entry.meansOfTransport.selectedEntry.displayName }}
                            </span>
                        </ng-container>
                    </label>
                    <ng-container *ngIf="isTravelBack(entry) && entry.isTravelBackEditable">
                        <div class="row align-items-center gap-2">
                            <div class="col-3">
                                <label *ngIf="!enableStandbyTravel">{{ getDesc(entry) }}</label>
                            </div>
                            <div class="col">
                                <pace-core-dropdown
                                    *ngIf="displayMeansOfTransport && entry.meansOfTransport"
                                    [(model)]="entry.meansOfTransport"
                                    [parentForm]="timesheetFormChildren"
                                ></pace-core-dropdown>
                                <pace-core-dropdown
                                    *ngIf="enableStandbyTravel && entry.travelBackDropdown"
                                    [(model)]="entry.travelBackDropdown"
                                    (valueChange)="entry.updateTravelBackWorkcode()"
                                    [parentForm]="timesheetFormChildren"
                                ></pace-core-dropdown>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <!-- NOTIFICATION LABEL AND QMNUM -->
                <div class="col-4">
                    <label class="col-form-label" translate="TIMESHEET_TABLE_NOTIFICATION_LABEL"></label>
                </div>
                <div class="col-8">
                    <label>{{ entry.notificationId.qmNum }}</label>
                </div>
                <div class="col-12">
                    <label class="col-form-label">
                        <span translate="TIMESHEET_TABLE_START_LABEL"></span>
                    </label>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-7 pe-0">
                            <pace-core-date-input
                                [(model)]="entry.startDate"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_START_DATE_LABEL_NOTIFICATION' | translate"
                            ></pace-core-date-input>
                        </div>
                        <div class="col-5">
                            <pace-core-time-input
                                [(model)]="entry.startTime"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_START_TIME_LABEL_NOTIFICATION' | translate"
                            ></pace-core-time-input>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <label class="col-form-label">
                        <span translate="TIMESHEET_TABLE_END_LABEL"></span>
                    </label>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-7 pe-0">
                            <pace-core-date-input
                                [(model)]="entry.endDate"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_END_DATE_LABEL_NOTIFICATION' | translate"
                            ></pace-core-date-input>
                        </div>
                        <div class="col-5">
                            <pace-core-time-input
                                [(model)]="entry.endTime"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_END_TIME_LABEL_NOTIFICATION' | translate"
                            ></pace-core-time-input>
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <label class="col-form-label" translate="TIMESHEET_TABLE_DURATION_LABEL"></label>
                </div>
                <div class="col-8">
                    <label>{{ getEntryDurationInHours(entry) | formatDuration: true }}</label>
                </div>
            </div>
            <!-- END OF NOTIFICATION ENTRIES -->

            <!-- ADDITIONAL TRAVEL BACK -->
            <div class="row row-border-bottom py-2" *ngIf="showAddTravelBack(entry, $index)">
                <div class="col-12">
                    <button
                        class="btn btn-small btn-primary"
                        [disabled]="readonly"
                        (click)="addAdditionalTravelBack(entry, $index)"
                        translate="TIMESHEET_ADD_TRAVEL_BACK_LABEL"
                    ></button>
                </div>
            </div>
            <!-- END OF ADDITIONAL TRAVEL BACK -->

            <!-- GAP ENTRIES -->
            <div class="row py-2 table-header-light-blue" *ngIf="isGap(entry)">
                <div class="col-12">
                    <button
                        class="btn btn-sm btn-danger"
                        (click)="addManualEntry($index)"
                        translate="TIMESHEET_ADD_TIMESLOT_LABEL"
                    ></button>
                </div>
            </div>
            <!-- END OF GAP ENTRIES -->

            <!-- MANUAL ENTRIES -->
            <div class="row py-2 row-border-bottom" *ngIf="isManual(entry)">
                <div class="col-12 text-end mb-3">
                    <button
                        *ngIf="!readonly"
                        class="btn btn-warning ms-3"
                        (click)="deleteEntry($index)"
                        [attr.aria-label]="('TIMESHEET_DELETE_MANUAL_ENTRY_LABEL' | translate) + $index"
                    >
                        <fa-icon [icon]="faTrashAlt"></fa-icon>
                    </button>
                </div>

                <div class="col-12 mb-2">
                    <div class="row">
                        <div class="col-4">
                            <label class="col-form-label" translate="TIMESHEET_TABLE_ACTIVITY_LABEL"></label>
                        </div>
                        <label *ngIf="!!entry.travelType; else displayTaskTypeDropdown" class="form-control-plaintext">
                            {{ entry.travelDescription }}
                        </label>
                        <ng-template #displayTaskTypeDropdown>
                            <div class="col">
                                <pace-core-dropdown
                                    [(model)]="entry.taskTypeDropdown"
                                    [parentForm]="timesheetFormChildren"
                                ></pace-core-dropdown>
                            </div>
                        </ng-template>
                    </div>
                </div>

                <!-- ADDRESS BUTTON -->
                <div class="col-12 mb-2">
                    <div class="row">
                        <div class="col-4">
                            <label class="col-form-label" translate="TIMESHEET_ADDRESS_LABEL"></label>
                        </div>
                        <ng-container *ngIf="displayAddress">
                            <div class="col-5">
                                <button
                                    class="btn address-btn"
                                    (click)="launchSelectAddressModal(entry)"
                                    [ngClass]="{
                                        'btn-secondary': entry.address && entry.address.isValid(),
                                        'btn-danger': !entry.address || !entry.address.isValid(),
                                    }"
                                    [disabled]="readonly"
                                    [attr.aria-label]="'TIMESHEET_LAUNCH_SELECT_ADDRESS_MODAL_LABEL' | translate"
                                >
                                    <span *ngIf="entry.address && entry.address.addrText.value">
                                        {{ entry.address.addrText.value }}
                                    </span>
                                    <span
                                        *ngIf="
                                            entry.address && !entry.address.addrText.value && entry.address.city.value
                                        "
                                    >
                                        {{ entry.address.city.value }}
                                    </span>
                                    <span
                                        *ngIf="
                                            !entry.address ||
                                            (!entry.address.addrText.value && !entry.address.city.value)
                                        "
                                        translate="TIMESHEET_ADDRESS_LABEL"
                                    ></span>
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <div class="col-12">
                    <div class="row">
                        <div class="col-12">
                            <label class="col-form-label">
                                <span translate="TIMESHEET_TABLE_START_LABEL"></span>
                            </label>
                        </div>
                        <div class="col-7 pe-0">
                            <pace-core-date-input
                                [(model)]="entry.startDate"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_MANUAL_START_DATE_LABEL' | translate"
                            ></pace-core-date-input>
                        </div>
                        <div class="col-5">
                            <pace-core-time-input
                                [(model)]="entry.startTime"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_MANUAL_START_TIME_LABEL' | translate"
                            ></pace-core-time-input>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12">
                            <label class="col-form-label">
                                <span translate="TIMESHEET_TABLE_END_LABEL"></span>
                            </label>
                        </div>
                        <div class="col-7 pe-0">
                            <pace-core-date-input
                                [model]="entry.endDate"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_MANUAL_END_DATE_LABEL' | translate"
                            ></pace-core-date-input>
                        </div>
                        <div class="col-5">
                            <pace-core-time-input
                                [(model)]="entry.endTime"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_MANUAL_END_TIME_LABEL' | translate"
                            ></pace-core-time-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <label class="col-form-label" translate="TIMESHEET_TABLE_DURATION_LABEL"></label>
                        </div>
                        <div class="col-8">
                            <label class="col-form-label fw-normal">{{
                                getEntryDurationInHours(entry) | formatDuration: true
                            }}</label>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END OF MANUAL ENTRIES -->

            <!-- BEGINNING OF END OF WORK -->
            <div class="row py-2 align-items-center row-border-bottom" *ngIf="isEoW(entry)">
                <!-- Activity -->
                <div class="row align-items-center">
                    <div class="col-4">
                        <label class="col-form-label" translate="TIMESHEET_TABLE_ACTIVITY_LABEL"></label>
                    </div>
                    <div class="col">
                        <label translate="TIMESHEET_END_OF_WORK_LABEL"></label>
                    </div>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-7 pe-0" [ngClass]="{ 'col-sm-6': shouldShowRemoveEowGapButton() }">
                            <pace-core-date-input
                                [(model)]="entry.endDate"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_END_OF_WORK_TABLE_END_DATE_LABEL' | translate"
                            ></pace-core-date-input>
                        </div>
                        <div class="col-5" [ngClass]="{ 'col-sm-4 pe-sm-0': shouldShowRemoveEowGapButton() }">
                            <pace-core-time-input
                                [(model)]="entry.endTime"
                                (focusEvent)="updateEoWMaxValue(entry)"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_END_OF_WORK_TABLE_END_TIME_LABEL' | translate"
                            ></pace-core-time-input>
                        </div>
                        <ng-container *ngIf="shouldShowRemoveEowGapButton()">
                            <div class="col pe-0 d-none d-sm-block">
                                <button
                                    class="btn btn-sm btn-secondary h-100 w-75"
                                    (click)="removeEowGap(entry)"
                                    [attr.aria-label]="'TIMESHEET_REMOVE_END_OF_WORK_GAP_LABEL' | translate"
                                >
                                    <fa-icon [icon]="faPause" size="lg" [rotate]="90"></fa-icon>
                                </button>
                            </div>
                            <div class="d-block d-sm-none py-2 text-end">
                                <button
                                    class="btn btn-md btn-secondary"
                                    (click)="removeEowGap(entry)"
                                    [attr.aria-label]="'TIMESHEET_REMOVE_END_OF_WORK_GAP_LABEL' | translate"
                                >
                                    <fa-icon [icon]="faPause" size="lg" [rotate]="90"></fa-icon>
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <!-- END OF END OF WORK -->
        </ng-container>
    </div>
    <!-- END OF MOBILE LAYOUT -->

    <!-- DESKTOP  LAYOUT -->
    <ng-template #desktopTemplate>
        <div class="row table-header">
            <div class="col-5">
                <label class="col-form-label">
                    <span translate="TIMESHEET_TABLE_START_LABEL"></span>
                    <span class="px-1">/</span>
                    <span translate="TIMESHEET_TABLE_END_LABEL"></span>
                </label>
            </div>
            <div class="col-1">
                <label class="col-form-label">
                    <span translate="TIMESHEET_TABLE_DURATION_LABEL"></span>
                </label>
            </div>
            <div class="col-3">
                <label class="col-form-label" translate="TIMESHEET_TABLE_ACTIVITY_LABEL"></label>
            </div>
            <div class="col-3">
                <label class="col-form-label" translate="TIMESHEET_TABLE_NOTIFICATION_LABEL"></label>
            </div>
        </div>
        <ng-container *ngFor="let entry of model.value; index as $index">
            <!-- START OF WORK -->
            <div *ngIf="isSoW(entry)" class="row py-2 align-items-center row-border-bottom">
                <div class="col-5">
                    <div class="row gap-2">
                        <div class="col-6">
                            <pace-core-date-input
                                [(model)]="entry.startDate"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_START_OF_WORK_TABLE_START_DATE_LABEL' | translate"
                            ></pace-core-date-input>
                        </div>
                        <div class="col-5">
                            <pace-core-time-input
                                [(model)]="entry.startTime"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_START_OF_WORK_TABLE_START_TIME_LABEL' | translate"
                            ></pace-core-time-input>
                        </div>
                    </div>
                </div>
                <div class="col-3 offset-1">
                    <label translate="TIMESHEET_START_OF_WORK_LABEL"></label>
                </div>
            </div>

            <!-- NOTIFICATION ENTRIES  -->
            <div *ngIf="isNormal(entry)" class="row py-2 align-items-center row-border-bottom">
                <div class="col-5">
                    <div class="row gap-2">
                        <div class="col-6">
                            <pace-core-date-input
                                [(model)]="entry.startDate"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_START_DATE_LABEL_NOTIFICATION' | translate"
                            ></pace-core-date-input>
                        </div>
                        <div class="col-5">
                            <pace-core-time-input
                                [(model)]="entry.startTime"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_START_TIME_LABEL_NOTIFICATION' | translate"
                            ></pace-core-time-input>
                        </div>
                    </div>
                    <div class="row gap-2 mt-2">
                        <div class="col-6">
                            <pace-core-date-input
                                [(model)]="entry.endDate"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_END_DATE_LABEL_NOTIFICATION' | translate"
                            ></pace-core-date-input>
                        </div>
                        <div class="col-5">
                            <pace-core-time-input
                                [(model)]="entry.endTime"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_END_TIME_LABEL_NOTIFICATION' | translate"
                            ></pace-core-time-input>
                        </div>
                    </div>
                </div>
                <div class="col-1">{{ getEntryDurationInHours(entry) | formatDuration: true }}</div>

                <!-- TODO NEEDS TO BE WORKED ON -->
                <div class="col-3">
                    <label *ngIf="!isTravelBack(entry) || (isTravelBack(entry) && !entry.isTravelBackEditable)">
                        {{ getDesc(entry) }}
                        <ng-container *ngIf="displayMeansOfTransport && entry.meansOfTransport">
                            <span *ngIf="isTravelTo(entry) || (isTravelBack(entry) && !entry.isTravelBackEditable)">
                                | {{ entry.meansOfTransport.selectedEntry.displayName }}
                            </span>
                        </ng-container>
                    </label>
                    <ng-container *ngIf="isTravelBack(entry) && entry.isTravelBackEditable">
                        <label *ngIf="!enableStandbyTravel">{{ getDesc(entry) }}</label>
                        <div class="row gap-2 mt-1">
                            <div class="col-7">
                                <pace-core-dropdown
                                    *ngIf="displayMeansOfTransport && entry.meansOfTransport"
                                    [(model)]="entry.meansOfTransport"
                                    [parentForm]="timesheetFormChildren"
                                ></pace-core-dropdown>
                                <pace-core-dropdown
                                    *ngIf="enableStandbyTravel && entry.travelBackDropdown"
                                    [(model)]="entry.travelBackDropdown"
                                    (valueChange)="entry.updateTravelBackWorkcode()"
                                    [parentForm]="timesheetFormChildren"
                                ></pace-core-dropdown>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div class="col-3">
                    <label>{{ entry.notificationId.qmNum }}</label>
                </div>
            </div>

            <!-- ADDITIONAL TRAVEL BACK -->
            <!-- TODO Pending refactoring -->
            <div class="row row-border-bottom py-2" *ngIf="showAddTravelBack(entry, $index)">
                <div class="col-12">
                    <button
                        class="btn btn-small btn-primary"
                        [disabled]="readonly"
                        (click)="addAdditionalTravelBack(entry, $index)"
                        translate="TIMESHEET_ADD_TRAVEL_BACK_LABEL"
                    ></button>
                </div>
            </div>

            <!-- GAP ENTRIES -->
            <!-- TODO change table header color -->
            <div class="row py-2 table-header-light-blue" *ngIf="isGap(entry)">
                <div class="col-12">
                    <button
                        class="btn btn-sm btn-danger"
                        (click)="addManualEntry($index)"
                        translate="TIMESHEET_ADD_TIMESLOT_LABEL"
                    ></button>
                </div>
            </div>

            <!-- MANUAL ENTRIES -->
            <div class="row py-2 row-border-bottom" *ngIf="isManual(entry)">
                <div class="col-5">
                    <div class="row gap-2">
                        <div class="col-6">
                            <pace-core-date-input
                                [(model)]="entry.startDate"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_MANUAL_START_DATE_LABEL' | translate"
                            ></pace-core-date-input>
                        </div>
                        <div class="col-5">
                            <pace-core-time-input
                                [(model)]="entry.startTime"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_MANUAL_START_TIME_LABEL' | translate"
                            ></pace-core-time-input>
                        </div>
                    </div>
                    <div class="row gap-2 mt-2">
                        <div class="col-6">
                            <pace-core-date-input
                                [model]="entry.endDate"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_MANUAL_END_DATE_LABEL' | translate"
                            ></pace-core-date-input>
                        </div>
                        <div class="col-5">
                            <pace-core-time-input
                                [(model)]="entry.endTime"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_MANUAL_END_TIME_LABEL' | translate"
                            ></pace-core-time-input>
                        </div>
                    </div>
                </div>
                <div class="col-1">{{ getEntryDurationInHours(entry) | formatDuration: true }}</div>
                <div class="col-3">
                    <label *ngIf="!!entry.travelType; else displayTaskTypeDropdown" class="form-control-plaintext">
                        {{ entry.travelDescription }}
                    </label>
                    <ng-template #displayTaskTypeDropdown>
                        <div class="col-10">
                            <pace-core-dropdown
                                [(model)]="entry.taskTypeDropdown"
                                [parentForm]="timesheetFormChildren"
                            ></pace-core-dropdown>
                        </div>
                    </ng-template>
                </div>
                <div class="col-3">
                    <div class="row">
                        <ng-container *ngIf="displayAddress">
                            <div class="col-5">
                                <button
                                    class="btn address-btn"
                                    (click)="launchSelectAddressModal(entry)"
                                    [ngClass]="{
                                        'btn-secondary': entry.address && entry.address.isValid(),
                                        'btn-danger': !entry.address || !entry.address.isValid(),
                                    }"
                                    [disabled]="readonly"
                                    [attr.aria-label]="'TIMESHEET_LAUNCH_SELECT_ADDRESS_MODAL_LABEL' | translate"
                                >
                                    <span *ngIf="entry.address && entry.address.addrText.value">
                                        {{ entry.address.addrText.value }}
                                    </span>
                                    <span
                                        *ngIf="
                                            entry.address && !entry.address.addrText.value && entry.address.city.value
                                        "
                                    >
                                        {{ entry.address.city.value }}
                                    </span>
                                    <span
                                        *ngIf="
                                            !entry.address ||
                                            (!entry.address.addrText.value && !entry.address.city.value)
                                        "
                                        translate="TIMESHEET_ADDRESS_LABEL"
                                    ></span>
                                </button>
                            </div>
                        </ng-container>
                        <button
                            *ngIf="!readonly"
                            class="col-auto btn btn-warning ms-3"
                            (click)="deleteEntry($index)"
                            [attr.aria-label]="('TIMESHEET_DELETE_MANUAL_ENTRY_LABEL' | translate) + $index"
                        >
                            <fa-icon [icon]="faTrashAlt"></fa-icon>
                        </button>
                    </div>
                </div>
            </div>
            <!-- END OF MANUAL ENTRIES -->

            <!-- BEGINNING OF END OF WORK -->
            <div class="row py-2 align-items-center row-border-bottom" *ngIf="isEoW(entry)">
                <div class="col-5">
                    <div class="row gap-2">
                        <div class="col-6">
                            <pace-core-date-input
                                [(model)]="entry.endDate"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_END_OF_WORK_TABLE_END_DATE_LABEL' | translate"
                            ></pace-core-date-input>
                        </div>
                        <div class="col-5">
                            <pace-core-time-input
                                [(model)]="entry.endTime"
                                (focusEvent)="updateEoWMaxValue(entry)"
                                (valueChange)="checkEntries()"
                                [parentForm]="timesheetFormChildren"
                                [ariaLabel]="'TIMESHEET_END_OF_WORK_TABLE_END_TIME_LABEL' | translate"
                            ></pace-core-time-input>
                        </div>
                    </div>
                </div>
                <div class="col-1">
                    <div class="col-6 min-w-50 px-0">
                        <button
                            *ngIf="shouldShowRemoveEowGapButton()"
                            class="btn btn-sm btn-secondary"
                            (click)="removeEowGap(entry)"
                            [attr.aria-label]="'TIMESHEET_REMOVE_END_OF_WORK_GAP_LABEL' | translate"
                        >
                            <fa-icon [icon]="faPause" [rotate]="90"></fa-icon>
                        </button>
                    </div>
                </div>
                <div class="col-3">
                    <label translate="TIMESHEET_END_OF_WORK_LABEL"></label>
                </div>
            </div>
            <!-- END OF END OF WORK -->
        </ng-container>
    </ng-template>
</div>
